module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "tp2"
  }, [_vm._v("The Myth of the"), _c('br'), _vm._v("\n    Non-Christian")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("Engaging Atheists, Nominal Christians"), _c('br'), _vm._v("\n    and the Spiritual But Not Religious")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "img50",
    attrs: {
      "alt": "",
      "src": "Images/4450_crowd1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("    Luke Cawley"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ivpress.com/books",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/IVP_Books_Logo.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceaacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 57
// module chunks = 0